<template>
	<div style="position: relative;">
		<slot name="prepend"></slot>
		<template v-for="(item, i) in dataList">
			<slot :item="item.item" :id="item.key" :index="i"></slot>
		</template>
		<slot name="append"></slot>
	</div>
</template>

<script>
	export default {
		name: 'cDrawSort',
		
		props: {
			value: [Array],
			
			disabled: Boolean
		},
		
		data() {
			return {
				dataList: [],
				translate: {
					x: 0,
					y: 0
				}
			}
		},
		
		watch: {
			value() {
				this.update();
			},
			
			disabled(val) {
				this.$children.forEach(item => item.disabled = val);
			}
		},
		
		mounted() {
			this.update();
		},
		
		methods: {
			update() {
				this.dataList = Array.from(this.value, (item, key) => {
					return {
						key,
						item
					}
				});
			},
			
			sortHandle(index, target) {
				var item = this.dataList.splice(index, 1)[0];
				this.dataList.splice(target, 0, item);
			},
			
			sortEnd() {
				this.$emit('input', Array.from(this.dataList, item => item.item));
			}
		}
	}
</script>
